import {ScrollingModule} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {ResetBackStateDirective} from 'src/app/infrastructure/directive/reset-back-state-.directive';
import {InfrastructureModule} from 'src/app/infrastructure/infrastructure.module';
import {ChangeButtonComponent} from 'src/app/ui/shared/component/button/change-button.component';
import {SuccessButtonComponent} from 'src/app/ui/shared/component/button/success-button.component';
import {CopyButtonComponent} from 'src/app/ui/shared/component/button/copy-button.component';
import {EditButtonComponent} from 'src/app/ui/shared/component/button/edit-button.component';
import {FilledButtonComponent} from 'src/app/ui/shared/component/button/filled-button.component';
import {CountdownTimerComponent} from 'src/app/ui/shared/component/countdown-timer/countdown-timer.component';
import {DocumentComponent} from 'src/app/ui/shared/component/docs/document.component';
import {FormInputDecoratorComponent} from 'src/app/ui/shared/component/input/form-input-decorator.component';
import {PopoverInputComponent} from 'src/app/ui/shared/component/input/popover-input.component';
import {RadioButtonComponent} from 'src/app/ui/shared/component/input/radio-button.component';
import {ShowHidePasswordComponent} from 'src/app/ui/shared/component/input/show-hide-password/show-hide-password.component';
import {TokenInputComponent} from 'src/app/ui/shared/component/input/token-input.component';
import {UploadMultipleFilesComponent} from 'src/app/ui/shared/component/input/upload-multiple-files.component';
import {NoticeComponent} from 'src/app/ui/shared/component/notice/notice.component';
import {ProgressBarComponent} from 'src/app/ui/shared/component/progress-bar/progress-bar';
import {AhorrobotUnitLinkedProductComponent} from 'src/app/ui/webapp/component/logo/product/ahorrobot-unit-linked-product.component';
import {EvoUnitLinkedProductComponent} from 'src/app/ui/webapp/component/logo/product/evo-unit-linked-product.component';
import {InversisInvestmentProductComponent} from 'src/app/ui/webapp/component/logo/product/inversis-investment-product.component';
import {UnitLinkedProductForChildComponent} from 'src/app/ui/webapp/component/logo/product/unit-linked-product-for-child.component';
import {FinizensLogoComponent} from 'src/app/ui/webapp/component/logo/finizens-logo.component';
import {PensionPlanProductComponent} from 'src/app/ui/webapp/component/logo/product/pension-plan-product.component';
import {ProductLogoComponent} from 'src/app/ui/webapp/component/logo/product/product-logo.component';
import {UnitLinkedProductComponent} from 'src/app/ui/webapp/component/logo/product/unit-linked-product.component';
import {MoneyPipe} from 'src/app/ui/shared/pipe/money.pipe';
import {NumberPipe} from 'src/app/ui/shared/pipe/number.pipe';
import {PercentagePipe} from 'src/app/ui/shared/pipe/percentage.pipe';
import {PluralizePipe} from 'src/app/ui/shared/pipe/pluralize.pipe';
import {SafePipe} from 'src/app/ui/shared/pipe/safe.pipe';
import {TranslationPipe} from 'src/app/ui/shared/pipe/translation.pipe';
import {AccordionComponent} from 'src/app/ui/shared/component/accordion/accordion.component';
import {ContentBoxComponent} from 'src/app/ui/shared/component/box/content-box.component';
import {WarningBoxComponent} from 'src/app/ui/shared/component/box/warning-box.component';
import {ButtonComponent} from 'src/app/ui/shared/component/button/button.component';
import {CustodianLogoComponent} from 'src/app/ui/shared/component/custodian-logo/custodian-logo.component';
import {PreviewModalPage} from 'src/app/ui/shared/component/docs/modal/preview-modal.page';
import {TemplateDocumentViewerComponent} from 'src/app/ui/shared/component/docs/template-document-viewer.component';
import {ErrorBoxComponent} from 'src/app/ui/shared/component/error/error-box.component';
import {CheckboxComponent} from 'src/app/ui/shared/component/input/checkbox.component';
import {DateRangePickerComponent} from 'src/app/ui/shared/component/input/date-range-picker.component';
import {DateTimeComponent} from 'src/app/ui/shared/component/input/datetime.component';
import {DropdownComponent} from 'src/app/ui/shared/component/input/dropdown.component';
import {InputComponent} from 'src/app/ui/shared/component/input/input.component';
import {InvestmentFundsSearchComponent} from 'src/app/ui/shared/component/input/investment-funds-search.component';
import {PensionPlanFundsSearchComponent} from 'src/app/ui/shared/component/input/pension-plan-funds-search.component';
import {RangeComponent} from 'src/app/ui/shared/component/input/range.component';
import {SearchComponent} from 'src/app/ui/shared/component/input/search/search.component';
import {ToggleComponent} from 'src/app/ui/shared/component/input/toggle.component';
import {TokenCharComponent} from 'src/app/ui/shared/component/input/token-char.component';
import {UploadComponent} from 'src/app/ui/shared/component/input/upload.component';
import {LinkComponent} from 'src/app/ui/shared/component/link/link.component';
import {LoaderOverplayComponent} from 'src/app/ui/shared/component/loader-overplay/loader-overplay.component';
import {SectionLoaderComponent} from 'src/app/ui/shared/component/section-loader/section-loader.component';
import {LogoComponent} from 'src/app/ui/shared/component/logo/logo.component';
import {CaserUlLogoComponent} from 'src/app/ui/shared/component/logo/partner/caser-ul-logo.component';
import {CecabankLogoComponent} from 'src/app/ui/shared/component/logo/partner/cecabank-logo.component';
import {InversisLogoComponent} from 'src/app/ui/shared/component/logo/partner/inversis-logo.component';
import {PartnerLogoComponent} from 'src/app/ui/shared/component/partner-logo/partner-logo.component';
import {PoweredByComponent} from 'src/app/ui/shared/component/powered-by/powered-by.component';
import {ProductIconComponent} from 'src/app/ui/shared/component/product/product-icon.component';
import {TabComponent} from 'src/app/ui/shared/component/tab/tab-bar.component';
import {ShowAmountsPipe} from 'src/app/ui/shared/pipe/show-amounts.pipe';

@NgModule({
  declarations: [
    FormInputDecoratorComponent,
    ButtonComponent,
    SuccessButtonComponent,
    FilledButtonComponent,
    InputComponent,
    PopoverInputComponent,
    TokenInputComponent,
    SearchComponent,
    InvestmentFundsSearchComponent,
    PensionPlanFundsSearchComponent,
    LogoComponent,
    LinkComponent,
    UploadComponent,
    UploadMultipleFilesComponent,
    CheckboxComponent,
    ToggleComponent,
    TokenCharComponent,
    PoweredByComponent,
    ProductIconComponent,
    ErrorBoxComponent,
    WarningBoxComponent,
    ContentBoxComponent,
    RangeComponent,
    TranslationPipe,
    MoneyPipe,
    PercentagePipe,
    NumberPipe,
    PluralizePipe,
    SafePipe,
    ShowAmountsPipe,
    FinizensLogoComponent,
    CaserUlLogoComponent,
    PensionPlanProductComponent,
    InversisInvestmentProductComponent,
    UnitLinkedProductComponent,
    AhorrobotUnitLinkedProductComponent,
    EvoUnitLinkedProductComponent,
    UnitLinkedProductForChildComponent,
    ProductLogoComponent,
    DateTimeComponent,
    DateRangePickerComponent,
    DropdownComponent,
    LoaderOverplayComponent,
    SectionLoaderComponent,
    AccordionComponent,
    CustodianLogoComponent,
    CecabankLogoComponent,
    InversisLogoComponent,
    PartnerLogoComponent,
    TemplateDocumentViewerComponent,
    PreviewModalPage,
    TabComponent,
    DocumentComponent,
    EditButtonComponent,
    CopyButtonComponent,
    ChangeButtonComponent,
    NoticeComponent,
    RadioButtonComponent,
    CountdownTimerComponent,
    ProgressBarComponent,
    ShowHidePasswordComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    InfrastructureModule,
    ScrollingModule,
    ResetBackStateDirective
  ],
  exports: [
    InfrastructureModule,
    FormInputDecoratorComponent,
    ButtonComponent,
    SuccessButtonComponent,
    FilledButtonComponent,
    InputComponent,
    PopoverInputComponent,
    TokenInputComponent,
    SearchComponent,
    InvestmentFundsSearchComponent,
    PensionPlanFundsSearchComponent,
    LogoComponent,
    LinkComponent,
    UploadComponent,
    UploadMultipleFilesComponent,
    CheckboxComponent,
    ToggleComponent,
    TokenCharComponent,
    PoweredByComponent,
    ProductIconComponent,
    ErrorBoxComponent,
    WarningBoxComponent,
    ContentBoxComponent,
    RangeComponent,
    DateTimeComponent,
    DateRangePickerComponent,
    DropdownComponent,
    TranslationPipe,
    MoneyPipe,
    PercentagePipe,
    NumberPipe,
    PluralizePipe,
    SafePipe,
    ShowAmountsPipe,
    FinizensLogoComponent,
    CaserUlLogoComponent,
    PensionPlanProductComponent,
    InversisInvestmentProductComponent,
    UnitLinkedProductComponent,
    AhorrobotUnitLinkedProductComponent,
    EvoUnitLinkedProductComponent,
    UnitLinkedProductForChildComponent,
    ProductLogoComponent,
    LoaderOverplayComponent,
    SectionLoaderComponent,
    AccordionComponent,
    CustodianLogoComponent,
    CecabankLogoComponent,
    InversisLogoComponent,
    PartnerLogoComponent,
    TemplateDocumentViewerComponent,
    TabComponent,
    DocumentComponent,
    EditButtonComponent,
    ChangeButtonComponent,
    CopyButtonComponent,
    RadioButtonComponent,
    NoticeComponent,
    CountdownTimerComponent,
    ProgressBarComponent,
  ]
})
export class SharedComponentModule {
}
